import { render, staticRenderFns } from "./charmTargetProcess.vue?vue&type=template&id=4aff8970"
import script from "./charmTargetProcess.vue?vue&type=script&lang=js"
export * from "./charmTargetProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aff8970')) {
      api.createRecord('4aff8970', component.options)
    } else {
      api.reload('4aff8970', component.options)
    }
    module.hot.accept("./charmTargetProcess.vue?vue&type=template&id=4aff8970", function () {
      api.rerender('4aff8970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/plan/charmTargetProcess.vue"
export default component.exports